import { combineReducers } from "redux"

import service from "reducers/service"
import system from "reducers/system"

const rootReducer = combineReducers({
  service,
  system,
})

export default rootReducer
